import React, { useState } from "react";
/*import { useForm, useStep } from "react-hooks-helper";*/
import Stepper from 'react-stepper-horizontal';

import CompStore from "./steps/CompStore";
import CompIdentification from "./steps/CompIdentification";
import CompOrder from "./steps/CompOrder";
import CompCheckout from "./steps/CompCheckout";


const steps = [
  { id: "store" },
  { id: "identification" },
  { id: "order" },
  { id: "checkout" }
];

const MultiStepStore = (props) => {
  const { step, navigation } = useState({ initialStep: 0, steps });
  const { id } = step;
  const stepperProps = {
    completeBarColor: "#0D0",
    defaultBarColor: "#F00",
    steps: [{ title: 'Seleção de Produto' }, { title: 'Identificação' }, { title: 'Dados do Pedido' }, { title: 'Finalizar' }]
  };
  const defaultProps = {
    navigation,
    cart: props.cart,
    language: props.language
  }
  switch (id) {
    case "store":
      return <>
        <Stepper {...stepperProps} activeStep={0} />
        <CompStore {...defaultProps}
          store={props.store}
          addProductCart={props.addProductCart}
          removeProductCart={props.removeProductCart}
          addPromotionalCode={props.addPromotionalCode}
          clearCart={props.clearCart}
        />
      </>;
    case "identification":
      return <>
        <Stepper {...stepperProps} activeStep={1} />
        <CompIdentification {...defaultProps} />
      </>;
    case "order":
      return <>
        <Stepper {...stepperProps} activeStep={2} />
        <CompOrder {...defaultProps} />
      </>;
    case "checkout":
      return <>
        <Stepper {...stepperProps} activeStep={3} />
        <CompCheckout {...defaultProps} />
      </>;
    default:
      return null;
  }
};

export default MultiStepStore;
